/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum ProductionOrderStatus {
  None = 'None',
  Open = 'Open',
  Checked = 'Checked',
  Active = 'Active',
  Finished = 'Finished',
  Reopened = 'Reopened',
  Interrupted = 'Interrupted'
}
